import { isInBrowser } from './reactOrNext';

export const isInE2eMode = () => {
  return isInBrowser() && window.Cypress ? true : false;
};
